<template>
  <div style="display: none"></div>
</template>
<script>
import { loadModules } from "esri-loader";
import MappingMixin from "@/mixins/mappingMixin";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapPopupInfoWindow",
  computed: {
    ...mapState([
      "is3d",
      "showPopupsOnClick",
      "sceneViewLoaded",
      "userSettings",
      "isConnectedToIntranet"
    ])
  },
  mixins: [MappingMixin],
  data() {
    return {
      basemapsLoaded: false,
      loadedBasemaps: [],
      copyGeometryAction: {
        title: "Kopier geometri",
        id: "copy-geometry",
        className: "esri-icon-duplicate"
      },
      elevationProfileAction: {
        title: "Høydeprofil",
        className: "esri-icon-line-chart",
        id: "generate-elevation-profile"
      },
      consequenceFactorsAction: {
        title: "Konsekvensberegning",
        className: "esri-icon-line-chart",
        id: "calculate-consequence-factors"
      },
      arealplanInnspillGenerationAction: {
        title: "Arealplan innspill",
        className: "esri-icon-documentation",
        id: "generate-arealplan-innspill"
      },
      relatedTableAction: {
        title: "Mer info",
        className: "esri-icon-description",
        id: "open-related-tables",
        test: "funker dette"
      }
    };
  },
  watch: {
    showPopupsOnClick: function(newVal) {
      if (newVal) {
        this.setupMapViewPopup();
        if (this.sceneViewLoaded) {
          this.setupSceneViewPopup();
        }
      }
    },
    sceneViewLoaded: function(newVal) {
      if (newVal) {
        this.setupSceneViewEventHandlers();
      }
    }
  },
  mounted: function() {
    this.setupEventHandlers();
  },
  methods: {
    ...mapActions([
      "setImageGalleryItems",
      "clearImageGalleryItems",
      "setCopiedGeometry",
      "addBottomSheet",
      "setShowImageGallery",
      "setPopupVisible",
      "setShowTabs",
      "setSnack",
      "setLoadingSnack"
    ]),
    setupEventHandlers: function() {
      this.$theMapViewObject.on("click", this.getFeatureData);
      this.setupMapViewPopup();
    },
    setupMapViewPopup: function() {
      loadModules(["esri/widgets/Popup"]).then(([Popup]) => {
        this.$theMapViewObject.popup = new Popup();
        this.$theMapViewObject.popup.dockOptions = {
          breakpoint: {
            width: 600,
            height: 544
          },
          position: "bottom-center"
        };
        this.enablePopupGeometryHighlight(this.$theMapViewObject);
        this.$theMapViewObject.popup.watch("visible", newVal => {
          this.setPopupVisible(newVal);
        });
        this.$theMapViewObject.popup.on(
          "trigger-action",
          this.triggerPopupAction
        );
      });
    },
    setupSceneViewEventHandlers: function() {
      this.$theSceneViewObject.on("click", this.getFeatureData);
      this.setupSceneViewPopup();
    },
    setupSceneViewPopup: function() {
      loadModules(["esri/widgets/Popup"]).then(([Popup]) => {
        this.$theSceneViewObject.popup = new Popup();
        this.$theSceneViewObject.popup.dockOptions = {
          breakpoint: {
            width: 600,
            height: 544
          },
          position: "bottom-center"
        };
        this.enablePopupGeometryHighlight(this.$theSceneViewObject);
        this.$theSceneViewObject.popup.watch("visible", newVal => {
          this.setPopupVisible(newVal);
        });
        this.$theSceneViewObject.popup.on(
          "trigger-action",
          this.triggerPopupAction
        );
      });
    },
    triggerPopupAction: function(event) {
      if (event.action.id === "copy-geometry") {
        this.copyGeometry();
      } else if (event.action.id === "generate-elevation-profile") {
        this.generateElevationProfile();
      } else if (event.action.id === "calculate-consequence-factors") {
        this.calculateConsequenceFactors();
      } else if (event.action.id === "generate-arealplan-innspill") {
        this.generateArealplanInnspill();
      } else if (event.action.id === "open-related-tables") {
        this.openRelatedTables(event.action);
      }
    },
    calculateConsequenceFactors: function() {
      let currentView = this.is3d
        ? this.$theSceneViewObject
        : this.$theMapViewObject;
      let geom = currentView.popup.selectedFeature.geometry;
      currentView.popup.close();
      this.addBottomSheet({
        type: "consequenceFactorAnalysis",
        title: "Konsekvensfaktorer",
        polygonGeometry: geom
      });
      this.setShowTabs(true);
    },
    generateArealplanInnspill: async function() {
      let currentView = this.is3d
        ? this.$theSceneViewObject
        : this.$theMapViewObject;
      const geom = currentView.popup.selectedFeature.geometry;
      currentView.popup.close();
      this.addBottomSheet({
        type: "arealplanAnalysis",
        title: "Arealplan innspill",
        polygonGeometry: geom
      });
      this.setShowTabs(true);
    },
    openRelatedTables: function(action) {
      let currentView = this.is3d
        ? this.$theSceneViewObject
        : this.$theMapViewObject;
      let attributes = currentView.popup.selectedFeature.attributes;
      action.tables.forEach(table => {
        this.addBottomSheet({
          type: "featureTable",
          value: attributes[table.key],
          isTable: true,
          ...table
        });
        this.setShowTabs(true);
      });
    },
    generateElevationProfile: function() {
      let currentView = this.is3d
        ? this.$theSceneViewObject
        : this.$theMapViewObject;
      // let geom = currentView.popup.selectedFeature.geometry;
      currentView.popup.close();
      this.addBottomSheet({
        type: "elevationProfile",
        title: "Høydeprofil",
        lineGeometry: currentView.popup.selectedFeature //<- kommenter inn denne når man går over til ny elevationprofile
        // lineGeometry: geom
      });
      this.setShowTabs(true);
    },
    copyGeometry: function() {
      let currentView = this.is3d
        ? this.$theSceneViewObject
        : this.$theMapViewObject;
      let geom = currentView.popup.selectedFeature.geometry;
      currentView.popup.close();
      this.setCopiedGeometry(geom);
      this.setSnack("Geometri ble kopiert");
    },
    addActionsToGraphicPopupTemplate: function(graphic, relatedTables = null) {
      let popupTemplate = graphic.popupTemplate;

      if (popupTemplate == null) {
        popupTemplate = {
          title: graphic.attributes.name ? graphic.attributes.name : "Uten navn"
        };
      }
      if (
        (popupTemplate.title === null || popupTemplate.title == "") &&
        graphic.hasOwnProperty("attributes")
      ) {
        popupTemplate.title = graphic.attributes.name;
      }
      let actions = [];

      if (graphic.geometry) {
        // if (graphic.geometry.type === "polyline") {
        //   actions.push(this.elevationProfileAction);
        // }
        if (graphic.geometry.type === "polygon") {
          actions.push(this.consequenceFactorsAction);
          if (this.isConnectedToIntranet) {
            actions.push(this.arealplanInnspillGenerationAction);
          }
        }
      }

      if (relatedTables) {
        let relatedTableAction = JSON.parse(
          JSON.stringify(this.relatedTableAction)
        );
        relatedTableAction.tables = relatedTables;
        actions.push(relatedTableAction);
      }
      actions.push(this.copyGeometryAction);
      popupTemplate.actions = actions;
      graphic.popupTemplate = popupTemplate;
    },
    getFeatureData: function(event) {
      if (this.showPopupsOnClick) {
        loadModules(["esri/Graphic", "esri/request", "dojo/promise/all"]).then(
          ([Graphic, esriRequest, all]) => {
            // Search for graphics at the clicked location
            let view = this.is3d
              ? this.$theSceneViewObject
              : this.$theMapViewObject;

            let promises = [];
            promises.push(
              new Promise((resolve, reject) => {
                view
                  .hitTest(event, {
                    exclude: [
                      this.$theMapObject.basemap.baseLayers,
                      this.$theMapViewObject.graphics
                    ]
                  })
                  .then(response => {
                    let graphics = [];
                    if (response.results.length) {
                      response.results.forEach(hitTestResult => {
                        this.addActionsToGraphicPopupTemplate(
                          hitTestResult.graphic
                        );

                        let existingGraphic = graphics.find(graphic => {
                          if (
                            graphic.attributes.hasOwnProperty("id") &&
                            hitTestResult.graphic.attributes.hasOwnProperty(
                              "id"
                            )
                          ) {
                            return (
                              graphic.attributes.id ===
                              hitTestResult.graphic.attributes.id
                            );
                          } else {
                            return false;
                          }
                        });
                        if (typeof existingGraphic === "undefined") {
                          graphics.push(hitTestResult.graphic);
                        }
                      });
                      resolve(graphics);
                    }
                    resolve(graphics);
                  })
                  .catch(error => {
                    reject(error);
                  });
              })
            );

            let layers = this.$theMapObject.layers.items;

            function findVisibleLayerIds(sublayer, profile) {
              let visibleLayers = [];

              if (sublayer.sublayers === null) {
                if (
                  sublayer.visible &&
                  (profile.hasOwnProperty("IdentifyLayers") &&
                    profile.IdentifyLayers.includes(sublayer.id))
                ) {
                  visibleLayers.push(sublayer.id);
                }
              } else {
                if (sublayer.visible && sublayer.sublayers) {
                  sublayer.sublayers.forEach(sl => {
                    visibleLayers = visibleLayers.concat(
                      findVisibleLayerIds(sl, profile)
                    );
                  });
                }
              }
              return visibleLayers;
            }

            layers.forEach(layer => {
              if (layer.visible && layer.sublayers) {
                let visibleLayers = [];
                let profile = this.$store.getters["getAddedMapProfile"](
                  layer.id
                );

                for (let s = 0; s < layer.sublayers.items.length; s++) {
                  let sublayer = layer.sublayers.items[s];
                  visibleLayers = visibleLayers.concat(
                    findVisibleLayerIds(sublayer, profile)
                  );
                }

                let layerDefs = {};

                for (let s = 0; s < layer.allSublayers.items.length; s++) {
                  let sublayer = layer.allSublayers.items[s];
                  if (sublayer.definitionExpression !== null) {
                    layerDefs[sublayer.id.toString()] =
                      sublayer.definitionExpression;
                  }
                }

                if (visibleLayers.length === 0) {
                  return;
                }
                // Set the parameters for the Identify
                let params = {};
                params.tolerance = 10;
                params.layerIds = visibleLayers;
                params.layerOption = "visible";
                params.returnFieldName = true;
                params.maxAllowableOffset = this.userSettings.identifyResultMaxAllowableOffsetInMeters;
                params.width = view.width;
                params.height = view.height;
                params.returnUnformattedValues = false;
                params.returnFieldName = true;
                params.returnGeometry = true;
                params.f = "json";
                params.imageDisplay = view.width + "," + view.height + "," + 96;
                params.layers = "visible:" + visibleLayers.join(",");
                params.geometryType = "esriGeometryPoint";
                params.layerDefs = layerDefs;

                // Set the geometry to the location of the view click
                params.geometry = event.mapPoint;

                params.mapExtent = view.extent;

                var form_data = new FormData();

                for (var key in params) {
                  if (typeof params[key] === "object") {
                    form_data.append(key, JSON.stringify(params[key]));
                  } else {
                    form_data.append(key, params[key]);
                  }
                }

                let url = layer.url;

                promises.push(
                  esriRequest(url + "/identify", {
                    body: form_data,
                    useProxy: profile.OnlyAccessibleViaIntranet
                  }).then(response => {
                    let results = response.data.results;

                    return results.map(result => {
                      let feature = Graphic.fromJSON(result);

                      let identifyTemplates = this.$store.getters[
                        "getAddedMapProfile"
                      ](layer.id).identify;

                      for (let j = 0; j < identifyTemplates.length; j++) {
                        let template = JSON.parse(
                          JSON.stringify(identifyTemplates[j])
                        );

                        // let template = identifyTemplates[j];

                        let relatedTables = template.relatedTables;

                        if (template.LayerIDList.includes(result.layerId)) {
                          if (
                            template.hasOwnProperty("useFunctionTemplate") &&
                            template.useFunctionTemplate
                          ) {
                            feature.popupTemplate = template.template;
                            feature.popupTemplate.content = identifyTemplates[
                              j
                            ].template.content.bind({});
                            continue;
                          }

                          if (template.template instanceof Array) {
                            if (
                              template.fjernRaderSomHarNullVerdierFraTemplate
                            ) {
                              for (let key in feature.attributes) {
                                if (
                                  feature.attributes[key] === null ||
                                  feature.attributes[key] === "Null" ||
                                  feature.attributes[key] === ""
                                ) {
                                  template.template = template.template.filter(
                                    item => {
                                      return !item.includes("{" + key + "}");
                                    }
                                  );
                                }
                              }
                            }
                            template.template = template.template.join("");

                            feature.popupTemplate = {
                              title: template.title,
                              content: template.template
                            };
                          } else {
                            if (
                              template.template.content instanceof Array &&
                              template.template.content.length > 0 &&
                              typeof template.template.content[0] === "string"
                            ) {
                              template.template.content = template.template.content.join(
                                ""
                              );
                            } else {
                              template.template = {
                                title: template.title,
                                content: template.template
                              };
                            }
                            feature.popupTemplate = template.template;
                          }

                          this.addActionsToGraphicPopupTemplate(
                            feature,
                            relatedTables
                          );
                          break;
                        }
                      }
                      return feature;
                    });
                  })
                );
              }
            });

            if (promises.length == 0) {
              document.getElementById("viewDiv").style.cursor = "auto";
              return;
            }

            all(promises)
              .then(
                results => {
                  document.getElementById("viewDiv").style.cursor = "auto";

                  let features = [];

                  for (let i = 0; i < results.length; i++) {
                    features = features.concat(results[i]);
                  }

                  if (features.length > 0) {
                    let imageGalleryItems = [];
                    let popupItems = [];

                    features.forEach(feature => {
                      if (feature.attributes.hasOwnProperty("webUrl")) {
                        let attributes = {
                          attr: feature.attributes,
                          geometry: feature.geometry
                        };
                        imageGalleryItems.push(attributes);
                      } else {
                        popupItems.push(feature);
                      }
                    });

                    if (
                      popupItems.length > 0 &&
                      imageGalleryItems.length == 0
                    ) {
                      view.popup.open({
                        features: popupItems.reverse(),
                        location: event.mapPoint
                      });
                      view.popup.collapsed = false;
                    }

                    if (imageGalleryItems.length > 0) {
                      this.clearImageGalleryItems();
                      this.setImageGalleryItems(imageGalleryItems);
                      this.setShowImageGallery(true);
                    }
                  }
                },
                error => {
                  document.getElementById("viewDiv").style.cursor = "auto";
                  console.error(error);
                }
              )
              .catch(error => {
                console.error(error);
                document.getElementById("viewDiv").style.cursor = "auto";
              });
            if (promises.length > 0) {
              document.getElementById("viewDiv").style.cursor = "wait";
            }
          }
        );
      }
    }
  }
};
</script>
<style>
.esri-popup__content {
  font-size: 14px !important;
}

.esri-popup__header-title {
  font-size: 14px;
  padding: 12px 24px;
}

.esri-popup__feature-buttons,
.esri-popup__feature-buttons [role="button"] {
  font-weight: 400;
  font-size: 12px;
}

.esri-popup__button {
  padding: 12px 10px;
}

table {
  font-family: "Roboto", sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.esri-widget tbody td {
  padding: 5px;
  font-size: 12px;
}

.esri-feature__main-container tbody tr:nth-child(odd) {
  background-color: whitesmoke;
  color: black;
}

.esri-popup__header-title {
  padding-left: 8px;
}

.esri-view-width-xsmall
  .esri-popup--is-docked-bottom-center
  .esri-popup__main-container {
  max-height: 50%;
}
</style>
